import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";
import Seo from "@/components/Seo";
import { EstimateButton, CallButton } from "@/components/CTAButtons";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Benji's Hauling & Junk Removal" description="The page you're looking for couldn't be found." path="/404" />
      <section className="flex min-h-[60vh] items-center bg-cream">
        <div className="container-x text-center">
          <PawPrint className="mx-auto h-14 w-14 text-gold" strokeWidth={2} />
          <h1 className="mt-6 font-heading text-5xl font-extrabold text-forest">404</h1>
          <p className="mt-3 text-lg text-charcoal/70">Looks like this page wandered off. Let's get you back on track.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-md bg-forest px-6 py-3.5 text-sm font-bold text-cream transition-all hover:-translate-y-0.5 hover:bg-forest-light">
              Back to Home
            </Link>
            <EstimateButton label="Get a Free Estimate" />
            <CallButton />
          </div>
        </div>
      </section>
    </>
  );
}
